import script from "./DrillHoleRadialSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrillHoleRadialSettings.vue?vue&type=script&setup=true&lang=ts"

import "./DrillHoleRadialSettings.vue?vue&type=style&index=0&id=20888ce9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20888ce9"]])

export default __exports__